export default __webpack_public_path__ + "static/media/eye.ca43f8a9.svg";